import { IconButton, TableCell, Typography } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { ExamAuditTableCellsPropsType } from '../Audit.types';
import { timelineLabel } from '@shared';

export function AuditTableCells({ entries, onSeekChange }: ExamAuditTableCellsPropsType) {
  const arr = Object.entries(entries);
  return (
    <>
      <TableCell size='small'>
        <IconButton onClick={() => onSeekChange(entries.start, true)}>
          <PlayCircleIcon />
        </IconButton>
      </TableCell>
      {arr.map(([keyName, value]) => {
        let displayValue;
        if ((keyName === 'start' || keyName === 'end') && typeof value === 'number') {
          displayValue = timelineLabel(value);
        } else if (Array.isArray(value)) {
          displayValue = value.join('\r\n');
        } else {
          displayValue = String(value);
        }
        return (
          <TableCell key={keyName} size='small'>
            <Typography variant='tableCell' sx={{ whiteSpace: 'pre' }}>
              {displayValue}
            </Typography>
          </TableCell>
        );
      })}
    </>
  );
}
